// removed by extract-text-webpack-plugin
module.exports = {"console-header":"Header__console-header","consoleHeader":"Header__console-header"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Console/components/Header/Header.tablet.css
// module id = 1356
// module chunks = 8